import React from "react";
import './acceuil.css'
import bg from '../../assets/bg.png'
import MyCarousel from "../Caroussel/Caroussel";
import imgHome from '../../assets/imgHome.jpg'
import imgHome1 from '../../assets/imgHome1.jpg'
import imgHome2 from '../../assets/imgHome2.jpg'
import imgHome3 from '../../assets/imgHome3.jpg'
import codeImg from '../../assets/developpeur.png'
import iconSub from '../../assets/utilisateur (1).png'
import { animated,useSpring } from "react-spring";
import TextAnimation from "../TextEffet/textEffet";
const textinf='Lorem ipsum dolor, sit amet consectetur adipisicing elit. A, dolor repellendus eveniet quos nemo asperiores tempore est possimus esse saepe ipsam consectetur aspernatur nesciunt consequatur ducimus non placeat, eius voluptatibus!'
function Acceuil (){
    const carouselData = [
        { id: 1, image: imgHome },
        { id: 2, image: imgHome1 },
        { id: 3, image: imgHome2 },
        { id: 4, image: imgHome3 },
      ];
     const styleCaroucel = {
    
    }
    const styleImage = {
        
        // height : 'max-content'
    }
    const Spring = useSpring({
        from: {
            opacity :0 },
        to: { 
            opacity :1 },
      })
    return <animated.div style={{...Spring}} className="bg-acceuil">
            <div className="textHome">
                <div className="bigText">
                    <h1>Commander a distantance</h1>
                    <img src={codeImg} alt="code image"  />
                </div>
                <h3>Nous sommmes la pour vous facilité la vie</h3>
                <p className="textAnime"><TextAnimation text={textinf} index={0}/> </p>
                <button className="buttonSingIn">
                    <img src={iconSub} style={{width:'30px'}} alt="icon sub"  />
                    Subscribe</button>
            </div>
            <div className="contentImageHome">
            {/* <div className="imgHome">
                <img src={imgHome} alt={imgHome} />
            </div> */}
                <MyCarousel carouselData={carouselData} styleCaroucel={styleCaroucel} styleImage={styleImage}/>

            </div>
    </animated.div>
}

export default Acceuil
